import { render, staticRenderFns } from "./CreateAddons.vue?vue&type=template&id=06f0e58f&scoped=true"
import script from "./CreateAddons.vue?vue&type=script&lang=js"
export * from "./CreateAddons.vue?vue&type=script&lang=js"
import style0 from "./CreateAddons.vue?vue&type=style&index=0&id=06f0e58f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0e58f",
  null
  
)

export default component.exports